export default [
  { value: 'createdAt_DESC', text: 'Сначала новые' },
  { value: 'createdAt_ASC', text: 'Сначала старые' }
]
